import React from 'react'
import Banner from './Banner'
import Showcase from './Showcase'

const Home = () => {

    return (
        <>
            <Banner />
            <Showcase />
        </>
    )
}

export default Home
